import {
    put, call, all, takeLatest, select
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import converter from './converter';
import * as api from './api';

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getSellers.toString(),
            defaultSaga({
                constants: constants.getSellers,
                api: api.getSellers
            })
        ),
        yield takeLatest(
            constants.getSeller.toString(),
            defaultSaga({
                constants: constants.getSeller,
                api: api.getSeller
            })
        )
    ]);
}